import type { ReactNode } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import { api, setCsrfToken } from '../../lib/api'
import { useSession } from '../../lib/session'

const TABS = [
  { to: '/op', label: 'Inbox', end: true },
  { to: '/op/bookings', label: 'Visits' },
  { to: '/op/availability', label: 'Availability' },
]

/**
 * The operator shell. Andrew reviews packets from his phone (10 §3), so this is a mobile-first
 * three-tab layout rather than a desktop dashboard, and every tap target is full-width.
 */
export function OperatorLayout({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const identity = useSession((state) => state.identity)
  const clear = useSession((state) => state.clear)

  async function signOut() {
    try {
      await api.post('/auth/staff/logout')
    } finally {
      setCsrfToken(null)
      clear()
      navigate('/staff/login', { replace: true })
    }
  }

  return (
    <div className="mx-auto max-w-4xl px-5 py-8">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="eyebrow m-0">Operator</p>
        <button
          type="button"
          onClick={() => void signOut()}
          className="inline-flex min-h-10 items-center rounded-btn border border-line bg-white px-4 text-sm font-semibold text-blue-deep transition-colors hover:border-blue hover:bg-blue-tint"
        >
          Sign out{identity?.role ? ` (${identity.role})` : ''}
        </button>
      </div>

      <nav className="mt-5 flex gap-1 rounded-pill border border-line bg-white p-1">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) =>
              `flex-1 rounded-pill px-4 py-2 text-center text-sm font-semibold transition-colors ${
                isActive ? 'bg-navy text-white' : 'text-body hover:bg-paper'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <div className="mt-7">{children}</div>
    </div>
  )
}
